import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHeartFull: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.6398 4.5C18.6398 2.5 15.3398 2.5 13.3398 4.5L12.0398 5.7L10.7398 4.5C8.73977 2.5 5.43977 2.5 3.43977 4.5C1.33977 6.5 1.73977 9.9 3.33977 12C5.33977 14.6 11.0398 20.5 11.3398 20.8C11.5398 20.9 11.7398 21 12.0398 21C12.3398 21 12.5398 20.9 12.7398 20.7C12.9398 20.5 18.7398 14.6 20.7398 11.9C22.2398 9.9 22.6398 6.5 20.6398 4.5Z',
    })
  )
}
